import { QueryRequestStatus } from '../enum/query-request-status';


export class IQueryRequestResult {
  public status!: QueryRequestStatus;
  public data: any;
}
